export default {
      id: "ic-nav-arrow-right-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }